import { ErrorModel } from "./errorModel";

export class DistribuidorModel {

    codigoFabril: string;
    codigoDistribuidor: string;
    tipoDocumento: string;//CatalogoTipoDocumento ;
    numeroIdentidad: string;
    razonSocial: string;
    nombreComercial: string;
    nombreCliente: string;
    // ciudad: number;
    canton: number;
    parroquia: number;
    direccion: string;
    referenciaDireccion: string;
    regional: string; //CatalogoRegional ;
    telefonoFijo1: string;
    telefonoFijo2: string;
    telefonoCelular1: string;
    telefonoCelular2: string;
    correoElectronico1: string;
    correoElectronico2: string;
    longitud: string; //BigDecimal ;
    latitud: string; //BigDecimal ;
    codigoVendedorAsignado: string;
    imagenes: string;
    tier: number;
    estadoEnDistribuidor: string; //CatalogoEstadoDistribuidor;
    provincia: string;
    correct: boolean;
    error?: ErrorModel;

    constructor() { }

    devolverModeloGridDistribuidor() {
        const objeto: DistribuidorModelInterface = {
            codigoFabril: 'codigoFabril',
            codigoDistribuidor: 'codigoDistribuidor',
            tipoDocumento: 'tipoDocumento',
            numeroIdentidad: 'numeroIdentidad',
            razonSocial: 'razonSocial',
            nombreComercial: 'nombreComercial',
            nombreCliente: 'nombreCliente',
            // ciudad: 'ciudad',
            canton: 'canton',
            parroquia: 'parroquia',
            direccion: 'direccion',
            referenciaDireccion: 'referenciaDireccion',
            regional: 'regional',
            telefonoFijo1: 'telefonoFijo1',
            telefonoFijo2: 'telefonoFijo2',
            telefonoCelular1: 'telefonoCelular1',
            telefonoCelular2: 'telefonoCelular2',
            correoElectronico1: 'correoElectronico1',
            correoElectronico2: 'correoElectronico2',
            longitud: 'longitud',
            latitud: 'latitud',
            codigoVendedorAsignado: 'codigoVendedorAsignado',
            imagenes: 'imagenes',
            tier: 'tier',
            estadoEnDistribuidor: 'estadoEnDistribuidor',
            provincia: 'provincia',
            isCorrect: 'isCorrect'
        };
        return objeto;
    }
}

export interface DistribuidorModelInterface {
    codigoFabril: string;
    codigoDistribuidor: string;
    tipoDocumento: string;//CatalogoTipoDocumento ;
    numeroIdentidad: string;
    razonSocial: string;
    nombreComercial: string;
    nombreCliente: string;
    // ciudad: string;
    canton: string;
    parroquia: string;
    direccion: string;
    referenciaDireccion: string;
    regional: string; //CatalogoRegional ;
    telefonoFijo1: string;
    telefonoFijo2: string;
    telefonoCelular1: string;
    telefonoCelular2: string;
    correoElectronico1: string;
    correoElectronico2: string;
    longitud: string; //BigDecimal ;
    latitud: string; //BigDecimal ;
    codigoVendedorAsignado: string;
    imagenes: string;
    tier: string;
    estadoEnDistribuidor: string;
    provincia: string;
    isCorrect: string;
}